import React from "react";
import {
  Box,
  Stack,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import { darken, lighten } from "@mui/material/styles";

const FiltroEscala = ({
  inverted = false,
  escala,
  filtroData,
  setFiltroData = () => {},
  setCheckChanges = () => {},
  theme,
  styles,
  type = "tráfego",
  unit = "%",
}) => {
  const handleChange = (label, checked) => {
    setFiltroData((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      return checked
        ? Array.from(new Set([...arr, label]))
        : arr.filter((l) => l !== label);
    });
    setCheckChanges(true);
  };

  return (
    <Box sx={styles.boxOP}>
      <Stack direction="column">
        <Typography sx={styles.text}>Filtro por Escala de {type}</Typography>

        <Typography sx={styles.textFine}>
          Selecione as faixas de {type} que deseja exibir no mapa.
        </Typography>
      </Stack>

      <Stack justifyContent="center" alignItems="start" mt={2} gap={1}>
        <FormGroup
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {escala
            ?.slice()
            ?.sort((a, b) => {
              const na = parseFloat(a.label);
              const nb = parseFloat(b.label);
              if (Number.isNaN(na)) return inverted ? 1 : -1;
              if (Number.isNaN(nb)) return inverted ? -1 : 1;
              return inverted ? na - nb : nb - na;
            })
            ?.map((escala, idx, arr) => {
              const currentLabel = escala.label;
              const nextLabel = arr[idx + 1]?.label;

              let label;
              if (currentLabel === "Sem Dados") {
                label = "Sem Dados / Fora da escala";
              } else if (nextLabel && nextLabel !== "Sem Dados") {
                label = `${currentLabel} ${unit} a ${nextLabel} ${unit}`;
              } else {
                label = `${currentLabel} ${unit} ou mais`;
              }

              return (
                <FormControlLabel
                  key={escala.label}
                  control={
                    <Checkbox
                      defaultChecked
                      checked={
                        Array.isArray(filtroData) &&
                        filtroData.includes(escala.label)
                      }
                      onChange={(e) =>
                        handleChange(escala.label, e.target.checked)
                      }
                    />
                  }
                  label={
                    <Stack sx={styles.stackCheckBox}>
                      <Box
                        sx={[
                          styles.boxEscalaCheckBox,
                          {
                            backgroundColor: escala.cor,
                            "&:hover": {
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? lighten(escala.cor, 0.5)
                                  : darken(escala.cor, 0.3),
                            },
                          },
                        ]}
                      />
                      <Typography sx={styles.subtitle}>{label}</Typography>
                    </Stack>
                  }
                />
              );
            })}
        </FormGroup>
      </Stack>

      <Button
        fullWidth
        sx={{ ...styles.buttonEscalaConfig, mt: 1 }}
        onClick={(e) => {
          setFiltroData([]);
          setCheckChanges(true);
        }}
      >
        Redefinir
      </Button>
    </Box>
  );
};

export default FiltroEscala;
